import React, { useCallback, useContext, useEffect, useState } from 'react';
import TnetPlatforms from './TnetPlatforms';
import InputMask from 'react-input-mask';
import { PAYMENT_FLOW_VIEWS } from '../helpers';
import { AppDataContext } from 'contexts/appData';
import { usePaymentContext } from '../PaymentProvider';
import { Checkbox } from 'components';
import clsx from 'clsx';
import { ModalsContext } from 'contexts/modals';
import { useCardForm, useFlittFormWidget } from 'libs/hooks/flitt';

const PayWithCard = () => {
  const { langs } = useContext(AppDataContext);
  const { callResponse, destroy } = useContext(ModalsContext);
  const { totalAmount, setPaymentFlowView, token, merchantId, saveCard, onSuccess: handleSuccess } = usePaymentContext();
  const { formRef, errors, sendForm, setFormValue } = useCardForm();

  const onSuccess = useCallback(
    (model) => {
      handleSuccess();
    },
    [destroy],
  );

  const onError = useCallback(
    (model) => {
      const error = model.attr('error');
      const { message } = error ?? { message: langs.ErrorMessage };

      callResponse({
        statusCode: false,
        statusMessage: message,
      });
    },
    [callResponse],
  );

  useFlittFormWidget({ token: token, element: '.checkout-form', onSuccess, onError });

  return (
    <div>
      <div className="p-8px d-flex position-relative mb-40px">
        <span className="svg-i back-arrow cursor-pointer" onClick={() => setPaymentFlowView(PAYMENT_FLOW_VIEWS.PAYMENT_METHODS_LIST)} />
        <h1 className="font-size-20 text-dark-text text-center mb-8px d-flex position-absolute absolute--center-position text-nowrap">
          {langs.NM_PayWithCard}
        </h1>
      </div>
      <form ref={formRef} className="checkout-form">
        <input type="hidden" name="payment_system" value="card" />
        <input type="hidden" name="merchant_id" value={merchantId} />
        <input type="hidden" name="token" value={token ?? ''} />

        <div className="font-bold font-size-20 mb-16px">{totalAmount}₾</div>

        <div className="d-flex flex-column gap-16px mb-32px">
          <InputMask
            mask="9999 9999 9999 9999"
            autoComplete="off"
            inputMode="numeric"
            maskChar={null}
            type="text"
            placeholder="ბარათის ნომერი"
            onChange={(e) => setFormValue('card_number', e.target.value)}
          >
            {(inputProps) => (
              <div className="position-relative w-100">
                <span className="svg-i h-24px w-24px credit-card-i position-absolute top-50 transformY-50 left-16px" />
                <input
                  {...inputProps}
                  name="card_number"
                  className={clsx('form-control outline-none pl-48px py-32px placeholder-text-primary font-medium font-size-14 text-primary-text-color', {
                    'error-outline': errors['card_number'],
                  })}
                />
              </div>
            )}
          </InputMask>

          <div className="d-flex gap-16px">
            <InputMask
              mask="99/99"
              placeholder="თვე/წელი"
              alwaysShowMask={false}
              maskChar={null}
              autoComplete="off"
              inputMode="text"
              onChange={(e) => {
                let val = e.target.value.replace(/\D/g, '');
                if (val.length > 4) val = val.slice(0, 4);
                if (val.length > 2) {
                  val = val.slice(0, 2) + '/' + val.slice(2);
                }
                setFormValue('expiry_date', val);
              }}
            >
              {(inputProps) => (
                <div className="position-relative w-100">
                  <span className="svg-i h-24px w-24px event-i position-absolute top-50 transformY-50 left-16px" />
                  <input
                    {...inputProps}
                    name="expiry_date"
                    className={clsx('form-control outline-none pl-48px py-32px placeholder-text-primary font-medium font-size-14 text-primary-text-color', {
                      'error-outline': errors['expiry_date'],
                    })}
                  />
                </div>
              )}
            </InputMask>

            <InputMask mask="999" maskChar={null} onChange={(e) => setFormValue('cvv2', e.target.value)} placeholder="CVV">
              {(inputProps) => (
                <div className="position-relative w-100">
                  <span className="svg-i h-24px w-24px lock-i position-absolute top-50 transformY-50 left-16px" />
                  <input
                    {...inputProps}
                    name="cvv2"
                    className={clsx('form-control outline-none pl-48px py-32px placeholder-text-primary font-medium font-size-14 text-primary-text-color', {
                      'error-outline': errors['cvv2'],
                    })}
                  />
                </div>
              )}
            </InputMask>
          </div>
        </div>
      </form>

      <button className="btn py-14px w-100 bg-market-color rounded-sm text-dark font-size-14" type="button" onClick={sendForm}>
        {langs.Pay}
      </button>

      {saveCard && (
        <div className="mb-40px">
          <TnetPlatforms />
        </div>
      )}
    </div>
  );
};

export default PayWithCard;
